import React, { useState, useEffect } from "react";
import axios from "axios";
import { Grid, TextField, Box, FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import BlogCard from "../components/BlogCard";

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [sortOrder, setSortOrder] = useState("newest"); // Default: Newest First
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [categories, setCategories] = useState([]);

    // Fetch blogs
    const getAllBlogs = async () => {
        try {
            const { data } = await axios.get("/api/v1/blog/all-blog");
            if (data?.success) {
                setBlogs(data?.blogs);
                // Extract unique categories
                const uniqueCategories = [
                    ...new Set(data.blogs.map((blog) => blog.category)),
                ];
                setCategories(["All", ...uniqueCategories]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllBlogs();
    }, []);
    const filteredBlogs = blogs
        .filter((blog) =>
            blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            blog.description.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .filter((blog) =>
            selectedCategory === "All" ? true : blog.category === selectedCategory
        );
    // Sort blogs by date
    const sortedBlogs = [...filteredBlogs].sort((a, b) => {
        return sortOrder === "newest"
            ? new Date(b.createdAt) - new Date(a.createdAt) // Newest First
            : new Date(a.createdAt) - new Date(b.createdAt); // Oldest First
    });



    return (
        <div>
            {/* Search & Sort Controls */}
            <Box display="flex" justifyContent="center" gap={2} mb={3} mt={4}>
                {/* Search Input */}
                <TextField
                    label="Search Blogs"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setSearchQuery(e.target.value)}
                    sx={{ width: "50%" }}
                />

                {/* Sort Dropdown */}
                <FormControl size="small" sx={{ minWidth: 150 }}>
                    <InputLabel id="sort-by-label">Sort By</InputLabel>
                    <Select
                        labelId="sort-by-label"
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        label="Sort By"
                    >
                        <MenuItem value="newest">Newest First</MenuItem>
                        <MenuItem value="oldest">Oldest First</MenuItem>
                    </Select>
                </FormControl>

                {/* Category Filter */}
                <FormControl size="small" sx={{ minWidth: 150 }}>
                    <InputLabel id="category-label">Category</InputLabel>
                    <Select
                        labelId="category-label"
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        label="Category"
                    >
                        {categories.map((cat, idx) => (
                            <MenuItem key={idx} value={cat}>
                                {cat}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

            </Box>

            {/* Blog Cards Grid */}
            <Grid container spacing={2}>
                {sortedBlogs.length > 0 ? (
                    sortedBlogs.map((blog) => (
                        <Grid item xs={12} sm={4} md={4} key={blog.id}>
                            <BlogCard
                                id={blog?._id}
                                isUser={localStorage.getItem("userId") === blog?.user?._id}
                                title={blog?.title}
                                description={blog?.description}
                                image={blog?.image}
                                time={blog.createdAt}
                            />
                        </Grid>
                    ))
                ) : (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "50vh",
                            textAlign: "center",
                        }}
                    >
                        <p>No blogs found...</p>
                    </div>
                )}
            </Grid>
        </div>
    );
};

export default Blogs;